import { Card, CardContent, CardHeader, LoadingButton } from "@bvhi/ui-base";
import { useTranslation } from "react-i18next";
import { useDownload } from "../../../../../../../hooks/use-download";
import { useCallback, useState } from "react";
import { getAppConfig } from "../../../../../../../config/config";
import { DownloadIcon } from "@bvhi/ui-icons";
import { useToast } from "../../../../../../../hooks/use-toast";

export const UsersDownloadCard = () => {
  const { t } = useTranslation(["users", "toasts"]);
  const { fetchFileAndDownload } = useDownload();
  const { pushCustomErrorToast, pushCustomSuccessToast } = useToast();

  const [isDownloading, setIsDownloading] = useState<boolean>(false);

  const downloadUsers = useCallback(() => {
    void (async () => {
      setIsDownloading(true);
      try {
        await fetchFileAndDownload(`${getAppConfig().env.baseUrl}/gateway/platform/v1/users/download`);
        pushCustomSuccessToast(t("toasts:toasts.download.success"));
      } catch (error) {
        console.error("Download failed:", error);
        pushCustomErrorToast(t("toasts:toasts.download.error"));
      } finally {
        setIsDownloading(false);
      }
    })();
  }, [fetchFileAndDownload, pushCustomSuccessToast, pushCustomErrorToast, t]);
  return (
    <Card>
      <CardHeader subheader={t("users:users.user.download.card.sub.title")} title={t("users:users.user.download.card.title")} />
      <CardContent>
        <LoadingButton loading={isDownloading} onClick={downloadUsers} startIcon={<DownloadIcon />}>
          {t("users:users.card.marketing-consent.button")}
        </LoadingButton>
      </CardContent>
    </Card>
  );
};
